import { NgModule } from '@angular/core';
import { SharedLandingModule } from '../shared/shared-landing.module';
import { BookRoutingModule } from './book-routing.module';
import { StatusComponent } from './status/status.component';
import { FormsModule } from '@angular/forms';
import { NewBookingComponent } from './new-booking/new-booking.component';
import { NewChooseTicketComponent } from './new-choose-ticket/new-choose-ticket.component';
import { TicketCardComponent } from './ticket-card/ticket-card.component';
import { BookFooterComponent } from './book-footer/book-footer.component';
import { LightboxModule } from 'ngx-lightbox';
import { CartComponent } from './cart/cart.component';
import { CartItemComponent } from './cart-item/cart-item.component';
import { ErrorMessageComponent } from './error-message/error-message.component';
import { CustomFormComponent } from './custom-form/custom-form.component';
import { ReviewCartComponent } from './review-cart/review-cart.component';
import { CancelPopupComponent } from './cancel-popup/cancel-popup.component';
import { ReviewComponent } from './review/review.component';
import { InfoComponent } from './info/info.component';
import { BookComponent } from './book.component';
import { ReviewDetailsMobileComponent } from './review-details-mobile/review-details-mobile.component';
import { SalesInfoComponent } from './sales-info/sales-info.component';
import { ReviewDetailsComponent } from './review-details/review-details.component';
import { SportBookingComponent } from './sport-booking/sport-booking.component';
import { ChooseTicketSportComponent } from './choose-ticket-sport/choose-ticket-sport.component';
import { SportTicketCardComponent } from './sport-ticket-card/sport-ticket-card.component';
import { ChooseSeatComponent } from './choose-seat/choose-seat.component';
@NgModule({
  declarations: [
    StatusComponent,
    NewBookingComponent,
    NewChooseTicketComponent,
    TicketCardComponent,
    BookFooterComponent,
    CartComponent,
    CartItemComponent,
    ErrorMessageComponent,
    CustomFormComponent,
    ReviewCartComponent,
    CancelPopupComponent,
    ReviewComponent,
    InfoComponent,
    BookComponent,
    ReviewDetailsMobileComponent,
    SalesInfoComponent,
    ReviewDetailsComponent,
    SportBookingComponent,
    ChooseTicketSportComponent,
    SportTicketCardComponent,
    ChooseSeatComponent,
  ],
  imports: [
    SharedLandingModule,
    BookRoutingModule,
    FormsModule,
    LightboxModule,
  ],
  exports: [NewBookingComponent, ChooseSeatComponent],
})
export class BookModule {}
